// @ts-nocheck
// Modeled on obd3-gui v1's UserStatusBadge — adapted for Cloud Telephony's
// user shape (`status` = 0/1 or 'Active'/'Blocked' + `expiry_date`).
//
// Three states:
//   • Expired  → validity date past today → warning badge
//   • Blocked  → status === 0 or 'Blocked' → destructive badge
//   • Active   → everything else            → success badge
import { Badge } from '@/components/ui/badge';

interface Props {
  user: { status?: number | string; expiry_date?: string | null };
}

export function isExpiredDate(v?: string | null) {
  if (!v) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(v);
  d.setHours(0, 0, 0, 0);
  return Number.isFinite(d.getTime()) && d.getTime() < today.getTime();
}

export function UserStatusBadge({ user }: Props) {
  if (isExpiredDate(user.expiry_date)) {
    return <Badge variant="warning">Expired</Badge>;
  }
  const blocked = user.status === 0 || user.status === '0' || user.status === 'Blocked' || user.status === 'Inactive';
  if (blocked) {
    return <Badge variant="destructive">Blocked</Badge>;
  }
  return <Badge variant="success">Active</Badge>;
}
